import { Provider } from '@angular/core';
import { TitleStrategy } from '@angular/router';

import { BrandTitleSuffix } from './util-title-strategy/brand-title-strategy';

export function provideRmaBrandSuffixTitle(): Provider[] {
  return [{ provide: TitleStrategy, useClass: BrandTitleSuffix }];
}
